<template>
  <div id="app">
    <navBar v-if="width >= 995" />
    <navBarMovil v-if="width < 995" />
    <router-view />
    <MyFooter/>
  </div>
</template>
<script>
import navBar from "./components/navBar";
import navBarMovil from "./components/navBarMovil";
import MyFooter from "./components/footer"
export default {
  components: {
    navBar,
    navBarMovil,
    MyFooter
  },
  data() {
    return {
      width: 0,
    };
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
};
</script>
<style></style>
